<template>
    <div class="box app-manage">
        <template v-if="isShow">
            <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <h1 style="text-align:left;color:rgb(102, 102, 102)">当前应用类型：{{authoName}}</h1>
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="">应用类型</el-form-item>
            <el-form-item label="" prop="SearchKey" >
                <el-select v-model="appModel.AppType" placeholder="请选择" @change="handleChange">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="SearchKey">
                <el-input  placeholder="请输入关键词" v-model="appModel.SearchKey"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd">添加应用</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%;background-color: #ecf5ff"   highlight-current-row 
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column align="center" label="ID" prop="OID" width="100">
            </el-table-column>
            <el-table-column prop="Name" label="应用名称" sortable width="200">
            </el-table-column>
           <el-table-column prop="Icon" label="应用图标" sortable width="120">
               <template slot-scope="scope">
                   <div class="demo-image__preview" >
                        <el-image 
                            style="width:60px;height:auto;margin-right:8px"
                            :src="scope.row.Icon" 
                            :preview-src-list="scope.row.Icon | filterLogo">
                        </el-image>
                    </div>
               </template>
            </el-table-column>
            <el-table-column prop="Icon" label="应用图标插画" sortable width="160">
               <template slot-scope="scope">
                   <div class="demo-image__preview" >
                        <el-image 
                            style="width:60px;height:auto;margin-right:8px"
                            :src="scope.row.Icon1" 
                            :preview-src-list="scope.row.Icon1 | filterIcon1">
                        </el-image>
                    </div>
               </template>
            </el-table-column>
            <el-table-column prop="IconColor" label="图标颜色" sortable width="120">
                <template slot-scope="scope">
                     <el-color-picker v-model="scope.row.IconColor"></el-color-picker>
                </template>
            </el-table-column>
            <el-table-column prop="IconShadow" label="图标阴影" sortable width="120">
                <template slot-scope="scope">
                     <el-color-picker v-model="scope.row.IconShadow"></el-color-picker>
                </template>
            </el-table-column>
            <el-table-column prop="Url" label="最新版本跳转地址" sortable width="200">
            </el-table-column>
            <el-table-column prop="AppType" label="应用类型" sortable width="120">
            </el-table-column>
            <el-table-column prop="CurrentVersion" label="当前版本" sortable width="120" >
            </el-table-column>
            <el-table-column prop="Developer" label="应用开发者" sortable width="120" >
            </el-table-column>
            <el-table-column prop="DownloadUrl" label="安装包路径" sortable width="120" >
            </el-table-column>
            <el-table-column prop="IsBackStage" label="是否有管理后台" sortable width="150">
                 <template slot-scope="scope">
                    <el-switch v-model="scope.row.IsBackStage" disabled=""></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="Descript" label="应用描述" sortable width="200" >
            </el-table-column>
            <el-table-column prop="IsShow" label="应用是否显示" sortable width="200" >
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.IsShow" disabled=""></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="Images" label="应用图片" sortable width="400" >
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image  v-for="(item,index) in scope.row.Images" :key="index"
                            style="width:60px;height:auto;margin-right:8px"
                            :src="item" 
                            :preview-src-list="scope.row.Images | filterImgs ">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="InitDataKey" label="初始化数据库表Key" sortable width="200" >
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="warning" @click="handleVersion(scope.row)">应用版本</el-button>
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="appModel.Page"
                layout="total,prev, pager, next, jumper"
                :total="listCount"
                :page-size="appModel.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData" :AppType="appModel.AppType"></edit>
        </template>
        <template v-if="!isShow">
            <versionManage :id="id" :AppType="AppType" @closeVersionManage="handleCloseVersion"></versionManage>
        </template>
    </div>
</template>

<script>
    import add from './add'
    import edit from './edit'
    import versionManage from './versionManage/list'
    import {GetAppsList,DeleteApp} from '../../api/app'
    export default {
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                authoList: [],
                authoName: null,
                editData: [],
                isdisabled: false,
                isShow: true,
                appModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    AppType: ''
                },
                options:[
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: 'android',
                        value: 'android'
                    },
                    {
                        label: 'web',
                        value: 'web'
                    },
                    {
                        label: 'dingding',
                        value: 'dingding'
                    },
                    {
                        label: 'windows',
                        value: 'windows'
                    },
                    {
                        label: 'ios',
                        value: 'ios'
                    }
                ],
                id: null,
                AppType: ''
            }
        },
        components: {
            add,
            edit,
            versionManage
        },
        watch: {
            'appModel.SearchKey': {
                handler(newVal) {
                    if(newVal === '') {
                        this.appModel.SearchKey = '';
                        this.GetAppsList();
                    }
                }
            }
        },
        filters: {
            filterImgs(images) {
                if(typeof(images)==='string') {
                    if(images.indexOf(';')!=-1) {
                        return images.split(';');
                    }else{
                        return images.split(' ');
                    }  
                }else{
                    return images;
                }
            },
            filterLogo(Icon) {
                if(Icon) {
                    return Icon.split()
                }
            },
            filterIcon1(Icon1) {
                if(Icon1) {
                    return Icon1.split()
                }
            }
        },
        mounted() {
            this.GetAppsList();
        },
        methods: {
            handleChange() {
                console.log('发生变化')
                this.appModel.Page = 1;
                this.GetAppsList();
            },
            GetAppsList() {
                let Images;
                this.dataList = [];
                GetAppsList(this.appModel).then(data=>{
                    if(!data.iserror) {
                        if(data.data.List.length > 0) {
                            data.data.List.forEach(element => {
                                if(element.Images) {
                                    if(element.Images.indexOf(';')!=-1) {
                                        Images = element.Images.split(';');
                                    }else{
                                        Images = element.Images.split(' ');
                                    }  
                                    element.Images =  Images;
                                }
                            });
                        }
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.appModel.Page = val;
                this.GetAppsList();
            },
            handleSearch() {
                if(this.appModel.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.appModel.Page = 1;
                this.GetAppsList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetAppsList();
            },
            handleCloseAdd() {
                this.isShowAdd = false; 
                this.GetAppsList();
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteApp(id);
                })
            },
            DeleteApp(id) {
                DeleteApp({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetAppsList();
                    }
                })
            },
            handleVersion(row) {
                this.id = row.OID;
                this.AppType = row.AppType;
                this.isShow = false;
            },
            handleCloseVersion() {
                this.isShow = true;
            }
        }
    }
</script>

<style>
.el-icon-circle-close:before {
    color: #ffffff;
}
.box.app-manage .el-table th, 
.box.app-manage .el-table tr {
    background-color: #ecf5ff;
}
</style>